import React from 'react';
import IconShiply from '@/assets/images/menu/icon-shiply.react.svg?react';
import { MultiApp } from '@/config/context';
import { PAGE_ID } from '@/infrastructure/reporter/datong/id';
import { reportClick } from '@/infrastructure/reporter/datong/report';
import { CapitalPlatform } from '@/infrastructure/utils/app';
import { MenuIcon } from '@/presentation/components/menu-icon';
import { IRouteConfig } from '../types';

export const shiplyRoutes = (): IRouteConfig[] => [
  {
    path: '/shiply',
    name: '应用升级 | 热修复',
    exact: true,
    whitelisted: true,
    icon: <MenuIcon icon={IconShiply} />,
    onMenuClick: () => reportClick(PAGE_ID.shiply.homepage, 'click_shiply_menu'),
    href: 'https://shiply.tds.qq.com?utm_source=buglypro&utm_medium=referral&source=buglypro',
    target: '_blank',
    versions: [MultiApp.Pro, MultiApp.Dji, MultiApp.Eu],
    platforms: [
      CapitalPlatform.Android,
      CapitalPlatform.IOS,
      CapitalPlatform.HarmonyOS,
      CapitalPlatform.Mac,
      CapitalPlatform.VisionOS,
      CapitalPlatform.AppleTV,
    ],
  },
];

export default shiplyRoutes;
